export const COMPONENT_NAME = 'VideoPlayout';
